<!-- exported-folders.component.html -->
<div class="container mx-auto p-8">
  <h1 class="text-3xl font-bold mb-8 mt-24">Carpetas Exportadas</h1>

  <!-- Filtros -->
  <div class="bg-white p-6 rounded-lg shadow-lg mb-8">
    <div class="flex justify-between items-center mb-4">
      <h2 class="text-xl font-semibold">Filtros</h2>
      <div class="flex space-x-4">
        <div class="relative flex items-center">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <i class="fas fa-search text-gray-400"></i>
          </div>
          <input 
            type="text" 
            [(ngModel)]="folderSearchTerm"
            (keyup.enter)="searchFolders()"
            placeholder="Buscar carpeta por nombre o descripción..." 
            class="pl-10 pr-20 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500">
          <div class="absolute inset-y-0 right-0 pr-3 flex items-center space-x-2">
            <button 
              *ngIf="folderSearchTerm"
              (click)="clearFolderSearch()" 
              class="text-gray-400 hover:text-gray-600"
              title="Limpiar búsqueda">
              <i class="fas fa-times"></i>
            </button>
            <button 
              (click)="searchFolders()" 
              class="text-blue-500 hover:text-blue-700"
              title="Buscar">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>
        <select 
          [(ngModel)]="dateFilter"
          (change)="onDateFilterChange()"
          class="rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500">
          <option value="all">Todas las fechas</option>
          <option value="today">Hoy</option>
          <option value="week">Esta semana</option>
          <option value="month">Este mes</option>
        </select>
        <button 
          (click)="loadFolders()" 
          class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center"
          [disabled]="isLoading">
          <i class="fas fa-sync-alt mr-2"></i>
          Recargar
        </button>
      </div>
    </div>
  </div>

  <!-- Lista de Carpetas -->
  <div class="bg-white rounded-lg shadow-lg overflow-hidden">
    
    <!-- Indicador de carga -->
    <div *ngIf="isLoading" class="flex justify-center items-center py-8">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
      <span class="ml-2 text-gray-600">Cargando carpetas...</span>
    </div>

    <!-- Mensaje si no hay carpetas -->
    <div *ngIf="!isLoading && filteredFolders.length === 0" class="text-center py-8 text-gray-500">
      <i class="fas fa-folder-open text-4xl mb-4"></i>
      <p *ngIf="folders.length === 0">No se encontraron carpetas exportadas</p>
      <p *ngIf="folders.length > 0 && folderSearchTerm">No se encontraron carpetas que coincidan con "{{folderSearchTerm}}"</p>
      <p *ngIf="folders.length > 0 && !folderSearchTerm">No se encontraron carpetas exportadas</p>
      <p class="text-sm">Las carpetas que crees aparecerán aquí</p>
    </div>

    <!-- Tabla de carpetas -->
    <table *ngIf="!isLoading && filteredFolders.length > 0" class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nombre</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Descripción</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Usuario</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Órdenes</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Repuestos</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tamaño</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr *ngFor="let folder of filteredFolders" 
            class="hover:bg-gray-50 cursor-pointer transition-colors duration-150"
            (click)="viewOrders(folder)"
            [title]="isMetadataOnlyExport(folder) ? 'Haz clic para ver los metadatos de esta exportación' : 'Haz clic para ver las órdenes de esta carpeta'">
          <td class="px-6 py-4 whitespace-nowrap">
            <div class="flex items-center">
              <i class="fas fa-folder text-yellow-500 mr-2"></i>
              <div>
                <div class="text-sm font-medium text-gray-900">{{folder.folderName}}</div>
                <div class="text-xs text-gray-500">ID: {{folder.folderId}}</div>
              </div>
            </div>
          </td>
          <td class="px-6 py-4">
            <div class="text-sm text-gray-900">{{folder.description || 'Sin descripción'}}</div>
          </td>
          <td class="px-6 py-4 whitespace-nowrap">
            <div class="text-sm text-gray-900">{{formatDateTime(folder.exportDate)}}</div>
          </td>
          <td class="px-6 py-4 whitespace-nowrap">
            <div class="text-sm text-gray-900">{{folder.userName}}</div>
          </td>
          <td class="px-6 py-4 whitespace-nowrap">
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              {{folder.orderCount}} órdenes
            </span>
          </td>
          <td class="px-6 py-4 whitespace-nowrap">
            <span *ngIf="getExportedSparePartCount(folder) !== null"
                  class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
              {{getExportedSparePartCount(folder)}} {{getExportedItemUnit(folder)}}
            </span>
            <span *ngIf="getExportedSparePartCount(folder) === null" class="text-sm text-gray-500">N/D</span>
          </td>
          <td class="px-6 py-4 whitespace-nowrap">
            <div class="text-sm text-gray-900">{{folder.totalSizeFormatted}}</div>
          </td>
          <td class="px-6 py-4 whitespace-nowrap">
            <div class="flex space-x-3" (click)="$event.stopPropagation()">
              <button 
                (click)="viewOrders(folder)" 
                class="text-blue-600 hover:text-blue-800"
                [title]="isMetadataOnlyExport(folder) ? 'Ver metadatos' : 'Ver órdenes'">
                <i class="fas fa-eye"></i>
              </button>
              <button 
                (click)="deleteFolder(folder)" 
                class="text-red-600 hover:text-red-800"
                title="Eliminar carpeta">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Modal de Órdenes -->
  <div *ngIf="selectedFolder" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" (click)="closeModal()">
    <div class="bg-white rounded-lg w-11/12 max-w-7xl max-h-[90vh] overflow-hidden shadow-lg" (click)="$event.stopPropagation()">
      
      <!-- Header del modal -->
      <div class="p-6 border-b bg-gray-50">
        <div class="flex justify-between items-center">
          <div>
            <h3 class="text-xl font-semibold text-gray-900">
              {{isMetadataOnlyExport(selectedFolder) ? 'Metadatos de' : 'Órdenes en'}} "{{selectedFolder.folderName}}"
            </h3>
            <p class="text-sm text-gray-600 mt-1">
              Exportado el {{formatDateTime(selectedFolder.exportDate)}} por {{selectedFolder.userName}}
            </p>
          </div>
          <button (click)="closeModal()" class="text-gray-500 hover:text-gray-700">
            <i class="fas fa-times text-xl"></i>
          </button>
        </div>
        
        <!-- Buscador mejorado -->
        <div *ngIf="!isMetadataOnlyExport(selectedFolder)" class="mt-4 flex items-center space-x-4">
          <div class="flex-1 relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <i class="fas fa-search text-gray-400"></i>
            </div>
            <input 
              type="text" 
              [(ngModel)]="searchTerm"
              (keyup.enter)="searchInFolder()"
              placeholder="Buscar por número, cliente, proveedor, siniestro, factura, vendedor, estado... (Presiona Enter para buscar)" 
              class="w-full pl-10 pr-12 py-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 focus-ring">
            <div class="absolute inset-y-0 right-0 pr-3 flex items-center space-x-2">
              <button 
                *ngIf="searchTerm && !isLoadingOrders"
                (click)="searchTerm = ''; searchInFolder()" 
                class="text-gray-400 hover:text-gray-600"
                title="Limpiar búsqueda">
                <i class="fas fa-times"></i>
              </button>
              <button 
                (click)="searchInFolder()" 
                class="text-blue-500 hover:text-blue-700"
                title="Buscar"
                [disabled]="isLoadingOrders">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
          <div class="flex items-center space-x-2">
            <span class="text-sm text-gray-500">
              {{selectedFolderOrders.length}} de {{totalOrders}} órdenes
            </span>
            <button 
              (click)="searchInFolder()" 
              class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center focus-ring"
              [disabled]="isLoadingOrders">
              <i class="fas fa-sync-alt mr-2" [ngClass]="{'loading-spinner': isLoadingOrders}"></i>
              Actualizar
            </button>
          </div>
        </div>
      </div>

      <!-- Contenido del modal -->
      <div class="p-6 overflow-y-auto max-h-[calc(90vh-200px)]">
        
        <!-- Información de la carpeta -->
        <div class="mb-6 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div class="bg-blue-50 p-4 rounded-lg">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-sm text-gray-500">Total de órdenes</p>
                <p class="text-2xl font-bold text-blue-700">{{selectedFolder.orderCount}}</p>
              </div>
              <div class="bg-blue-100 p-3 rounded-full">
                <i class="fas fa-list-alt text-blue-500 text-xl"></i>
              </div>
            </div>
          </div>
          
          <div class="bg-green-50 p-4 rounded-lg">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-sm text-gray-500">{{isMetadataOnlyExport(selectedFolder) ? 'Archivo' : 'Tamaño total'}}</p>
                <p class="text-2xl font-bold text-green-700" *ngIf="!isMetadataOnlyExport(selectedFolder)">{{selectedFolder.totalSizeFormatted}}</p>
                <p class="text-sm font-semibold text-green-700 break-all" *ngIf="isMetadataOnlyExport(selectedFolder)">{{getExportFileName(selectedFolder)}}</p>
              </div>
              <div class="bg-green-100 p-3 rounded-full">
                <i class="fas text-green-500 text-xl" [ngClass]="isMetadataOnlyExport(selectedFolder) ? 'fa-file-excel' : 'fa-hdd'"></i>
              </div>
            </div>
          </div>
          
          <div class="bg-purple-50 p-4 rounded-lg">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-sm text-gray-500">{{isMetadataOnlyExport(selectedFolder) ? 'Filas/Repuestos exportados' : (searchTerm ? 'Resultados filtrados' : 'Órdenes mostradas')}}</p>
                <p class="text-2xl font-bold text-purple-700">{{isMetadataOnlyExport(selectedFolder) ? (getExportedSparePartCount(selectedFolder) || 0) : selectedFolderOrders.length}}</p>
                <p class="text-xs text-gray-400" *ngIf="!isMetadataOnlyExport(selectedFolder)">de {{totalOrders}} totales</p>
                <p class="text-xs text-gray-400" *ngIf="isMetadataOnlyExport(selectedFolder)">{{getExportTypeLabel(selectedFolder)}}</p>
              </div>
              <div class="bg-purple-100 p-3 rounded-full">
                <i class="fas text-purple-500 text-xl" [ngClass]="searchTerm ? 'fa-filter' : 'fa-list'"></i>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="isMetadataOnlyExport(selectedFolder)" class="mb-6 bg-gray-50 border border-gray-200 rounded-lg p-5">
          <h4 class="font-semibold text-gray-800 mb-3 flex items-center">
            <i class="fas fa-info-circle mr-2"></i>
            Datos guardados para esta exportación
          </h4>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
            <div>
              <span class="text-gray-500 block">Tipo</span>
              <span class="font-medium">{{getExportTypeLabel(selectedFolder)}}</span>
            </div>
            <div>
              <span class="text-gray-500 block">Archivo generado</span>
              <span class="font-medium break-all">{{getExportFileName(selectedFolder)}}</span>
            </div>
            <div>
              <span class="text-gray-500 block">Órdenes incluidas</span>
              <span class="font-medium">{{selectedFolder.orderCount}}</span>
            </div>
            <div>
              <span class="text-gray-500 block">Filas/Repuestos</span>
              <span class="font-medium">{{getExportedSparePartCount(selectedFolder) || 0}} {{getExportedItemUnit(selectedFolder)}}</span>
            </div>
            <div>
              <span class="text-gray-500 block">Tamaño del archivo</span>
              <span class="font-medium">{{selectedFolder.totalSizeFormatted}}</span>
            </div>
            <div>
              <span class="text-gray-500 block">Exportado</span>
              <span class="font-medium">{{getMetadataExportedAt(selectedFolder)}}</span>
            </div>
          </div>
          <p class="text-xs text-gray-500 mt-4">
            Esta exportación guarda solo metadatos para evitar demoras al generar el Excel. No contiene el snapshot completo de cada orden.
          </p>
        </div>

        <!-- Indicador de carga -->
        <div *ngIf="!isMetadataOnlyExport(selectedFolder) && isLoadingOrders" class="flex justify-center items-center py-8">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
          <span class="ml-2 text-gray-600">Cargando órdenes...</span>
        </div>

        <!-- Mensaje si no hay órdenes -->
        <div *ngIf="!isMetadataOnlyExport(selectedFolder) && !isLoadingOrders && selectedFolderOrders.length === 0" class="text-center py-8">
          <div *ngIf="searchTerm && totalOrders > 0" class="text-gray-500">
            <i class="fas fa-search text-4xl mb-4 text-yellow-500"></i>
            <p class="font-medium">No se encontraron órdenes que coincidan con "{{searchTerm}}"</p>
            <p class="text-sm mt-2">Intenta con otros términos de búsqueda o 
              <button (click)="searchTerm = ''; performSearch('')" class="text-blue-600 hover:text-blue-800 underline">
                ver todas las órdenes
              </button>
            </p>
            <p class="text-xs text-gray-400 mt-3">
              Búsqueda en: número de orden, cliente, proveedor, siniestro, factura, vendedor, estado, ID, vehículo
            </p>
          </div>
          
          <div *ngIf="!searchTerm || totalOrders === 0" class="text-gray-500">
            <i class="fas fa-folder-open text-4xl mb-4"></i>
            <p class="font-medium">No hay órdenes en esta carpeta</p>
            <p class="text-sm">La carpeta está vacía o no se pudieron cargar las órdenes</p>
          </div>
        </div>

        <!-- Tabla de órdenes (formato similar a order-history) -->
        <div *ngIf="!isMetadataOnlyExport(selectedFolder) && !isLoadingOrders && selectedFolderOrders.length > 0" class="overflow-x-auto">
          <!-- Banner informativo sobre funcionalidad -->
          <div class="info-banner bg-yellow-50 border-l-4 border-yellow-400 p-3 mb-4">
            <p class="text-sm text-yellow-700">
              <i class="fas fa-info-circle mr-1"></i>
              Haz clic en cualquier orden para ver sus repuestos y detalles completos
            </p>
          </div>
          
          <!-- Banner sobre búsqueda cuando hay filtro activo -->
          <div *ngIf="searchTerm" class="info-banner bg-blue-50 border-l-4 border-blue-400 p-3 mb-4">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-sm text-blue-700">
                  <i class="fas fa-filter mr-1"></i>
                  Mostrando {{selectedFolderOrders.length}} resultados de {{totalOrders}} totales para "{{searchTerm}}"
                </p>
              </div>
              <button (click)="searchTerm = ''; performSearch('')" 
                      class="text-blue-600 hover:text-blue-800 text-sm underline">
                Limpiar filtro
              </button>
            </div>
          </div>
          
          <table class="min-w-full bg-white">
            <thead>
              <tr class="bg-gray-100">
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <i class="fas fa-chevron-down mr-1"></i>ID
                </th>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha de Creación</th>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Orden</th>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Siniestro</th>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cliente</th>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Proveedor</th>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha de Llegada</th>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Repuestos</th>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Exportado</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let folderOrder of getDisplayedOrders()">
                <!-- Fila principal de la orden (clickeable) -->
                <tr class="border-b hover:bg-gray-50 cursor-pointer transition-colors duration-150"
                    [ngClass]="{
                      'bg-blue-50': folderOrder.orderSnapshot?.orderStatus === 'CREADO',
                      'bg-orange-50': folderOrder.orderSnapshot?.orderStatus === 'LLEGO' || folderOrder.orderSnapshot?.orderStatus === 'EN PROCESO',
                      'bg-green-50': folderOrder.orderSnapshot?.orderStatus === 'FINALIZADO',
                      'bg-red-50': folderOrder.orderSnapshot?.orderStatus === 'CANCELADO' || folderOrder.orderSnapshot?.orderStatus === 'ATENCION',
                      'bg-purple-50': folderOrder.orderSnapshot?.orderStatus === 'PENDIENTE' || folderOrder.orderSnapshot?.orderStatus === 'REPUESTOS-PENDIENTES',
                      'bg-gray-100': isOrderExpanded(folderOrder)
                    }"
                    (click)="toggleOrderExpansion(folderOrder)"
                    title="Haz clic para ver detalles y repuestos">
                  <td class="px-4 py-2">
                    <div class="flex items-center">
                      <i class="fas mr-2 transition-transform duration-200"
                         [ngClass]="isOrderExpanded(folderOrder) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                      {{folderOrder.orderSnapshot?.orderId || folderOrder.orderId}}
                    </div>
                  </td>
                  <td class="px-4 py-2">{{formatDate(folderOrder.orderSnapshot?.creationDate)}}</td>
                  <td class="px-4 py-2 font-medium">{{folderOrder.orderSnapshot?.orderNumber}}</td>
                  <td class="px-4 py-2">{{folderOrder.orderSnapshot?.siniestro}}</td>
                  <td class="px-4 py-2">{{folderOrder.orderSnapshot?.clientName}}</td>
                  <td class="px-4 py-2">{{folderOrder.orderSnapshot?.providerName}}</td>
                  <td class="px-4 py-2">
                    <span class="px-2 py-1 text-xs rounded-full" [ngClass]="getStatusClass(folderOrder.orderSnapshot?.orderStatus)">
                      {{folderOrder.orderSnapshot?.orderStatus}}
                    </span>
                  </td>
                  <td class="px-4 py-2">{{formatDate(folderOrder.orderSnapshot?.expectedArrivalDate)}}</td>
                  <td class="px-4 py-2 text-center">
                    <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                      {{getOrderSpareParts(folderOrder).length}} repuestos
                    </span>
                  </td>
                  <td class="px-4 py-2 font-semibold">{{getOrderTotalFromSnapshot(folderOrder) | currency}}</td>
                  <td class="px-4 py-2 text-sm text-gray-500">{{formatDateTime(folderOrder.exportedAt)}}</td>
                </tr>
                
                <!-- Fila expandida con detalles de la orden -->
                <tr *ngIf="isOrderExpanded(folderOrder)" class="bg-gray-50 fade-in">
                  <td colspan="11" class="px-4 py-6">
                    <div class="expanded-content bg-white rounded-lg shadow-sm border p-6 section-card">
                      <!-- Información completa de la orden -->
                      <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
                        <!-- Información General -->
                        <div class="bg-blue-50 p-4 rounded-lg info-card">
                          <h4 class="font-semibold text-blue-800 mb-3 flex items-center text-shadow">
                            <i class="fas fa-info-circle mr-2"></i>
                            Información General
                          </h4>
                          <div class="space-y-2 text-sm">
                            <div class="flex justify-between">
                              <span class="text-gray-600">ID:</span>
                              <span class="font-medium">{{folderOrder.orderSnapshot?.orderId}}</span>
                            </div>
                            <div class="flex justify-between">
                              <span class="text-gray-600">Número de Orden:</span>
                              <span class="font-medium">{{folderOrder.orderSnapshot?.orderNumber}}</span>
                            </div>
                            <div class="flex justify-between">
                              <span class="text-gray-600">Factura:</span>
                              <span class="font-medium">{{folderOrder.orderSnapshot?.invoiceNumber}}</span>
                            </div>
                            <div class="flex justify-between">
                              <span class="text-gray-600">Vendedor:</span>
                              <span class="font-medium">{{folderOrder.orderSnapshot?.employeeName}}</span>
                            </div>
                            <div class="flex justify-between">
                              <span class="text-gray-600">Vehículo:</span>
                              <span class="font-medium">{{folderOrder.orderSnapshot?.carMakeModel}}</span>
                            </div>
                            <div class="flex justify-between">
                              <span class="text-gray-600">Siniestro:</span>
                              <span class="font-medium">{{folderOrder.orderSnapshot?.siniestro}}</span>
                            </div>
                            <div class="flex justify-between">
                              <span class="text-gray-600">Cliente UY:</span>
                              <span class="font-medium">{{folderOrder.orderSnapshot?.clienteUY}}</span>
                            </div>
                          </div>
                        </div>
                        
                        <!-- Cliente y Proveedor -->
                        <div class="bg-green-50 p-4 rounded-lg info-card">
                          <h4 class="font-semibold text-green-800 mb-3 flex items-center text-shadow">
                            <i class="fas fa-users mr-2"></i>
                            Cliente y Proveedor
                          </h4>
                          <div class="space-y-2 text-sm">
                            <div>
                              <span class="text-gray-600 block">Cliente:</span>
                              <span class="font-medium">{{folderOrder.orderSnapshot?.clientName}}</span>
                              <span class="text-gray-500 text-xs block">{{folderOrder.orderSnapshot?.clientPhone}}</span>
                            </div>
                            <div>
                              <span class="text-gray-600 block">Proveedor:</span>
                              <span class="font-medium">{{folderOrder.orderSnapshot?.providerName}}</span>
                              <span class="text-gray-500 text-xs block">{{folderOrder.orderSnapshot?.providerPhone}}</span>
                            </div>
                            <div class="flex justify-between">
                              <span class="text-gray-600">Dirección:</span>
                              <span class="font-medium text-right">{{folderOrder.orderSnapshot?.deliveryAddress}}</span>
                            </div>
                          </div>
                        </div>
                        
                        <!-- Fechas y Estado -->
                        <div class="bg-purple-50 p-4 rounded-lg info-card">
                          <h4 class="font-semibold text-purple-800 mb-3 flex items-center text-shadow">
                            <i class="fas fa-calendar mr-2"></i>
                            Fechas y Estado
                          </h4>
                          <div class="space-y-2 text-sm">
                            <div class="flex justify-between">
                              <span class="text-gray-600">Creación:</span>
                              <span class="font-medium">{{formatDate(folderOrder.orderSnapshot?.creationDate)}}</span>
                            </div>
                            <div class="flex justify-between">
                              <span class="text-gray-600">Llegada:</span>
                              <span class="font-medium">{{formatDate(folderOrder.orderSnapshot?.expectedArrivalDate)}}</span>
                            </div>
                            <div class="flex justify-between">
                              <span class="text-gray-600">Exportado:</span>
                              <span class="font-medium">{{formatDateTime(folderOrder.exportedAt)}}</span>
                            </div>
                            <div class="flex justify-between items-center">
                              <span class="text-gray-600">Estado:</span>
                              <span class="px-2 py-1 text-xs rounded-full" [ngClass]="getStatusClass(folderOrder.orderSnapshot?.orderStatus)">
                                {{folderOrder.orderSnapshot?.orderStatus}}
                              </span>
                            </div>
                            <div class="flex justify-between">
                              <span class="text-gray-600">Es Exportación:</span>
                              <span class="font-medium">{{folderOrder.orderSnapshot?.isExport === 'si' ? 'Sí' : 'No'}}</span>
                            </div>
                            <div class="flex justify-between">
                              <span class="text-gray-600">Enviar:</span>
                              <span class="font-medium">{{folderOrder.orderSnapshot?.sendYesOrNo === 'true' ? 'Sí' : 'No'}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <!-- Tabla de Repuestos -->
                      <div class="mt-6">
                        <h4 class="font-semibold mb-3 flex items-center">
                          <i class="fas fa-cogs mr-2"></i>
                          Repuestos ({{getOrderSpareParts(folderOrder).length}})
                        </h4>
                        
                        <div *ngIf="getOrderSpareParts(folderOrder).length === 0" class="text-center py-4 text-gray-500">
                          <i class="fas fa-exclamation-triangle text-yellow-500 text-2xl mb-2"></i>
                          <p>No hay repuestos registrados en esta orden</p>
                        </div>
                        
                        <div *ngIf="getOrderSpareParts(folderOrder).length > 0" class="table-responsive-container table-scroll-horizontal">
                          <div class="info-banner bg-blue-50 border-l-4 border-blue-400 p-3 mb-4">
                            <p class="text-sm text-blue-700">
                              <i class="fas fa-info-circle mr-1"></i>
                              Haz clic en cualquier repuesto para ver todos sus detalles
                            </p>
                          </div>
                          
                          <table class="table-responsive table-mobile-cards table-fade-in">
                            <thead class="bg-gray-100">
                              <tr>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                                  <i class="fas fa-chevron-down mr-1"></i>Nombre
                                </th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Código</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Paquete</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Estado</th>
                                <th class="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase">Cantidad</th>
                                <th class="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase">Precio Unit.</th>
                                <th class="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase">Total</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Llegada</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">País</th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container *ngFor="let part of getOrderSpareParts(folderOrder); let i = index">
                                <!-- Fila principal del repuesto (clickeable) -->
                                <tr class="border-b border-gray-200 hover:bg-gray-50 cursor-pointer transition-colors duration-150"
                                    [ngClass]="{
                                      'bg-gray-50': i % 2 === 1,
                                      'bg-blue-50': isSparePartExpanded(folderOrder.orderSnapshot?.orderId || folderOrder.orderId, part.sparePartId)
                                    }"
                                    (click)="toggleSparePartExpansion(folderOrder.orderSnapshot?.orderId || folderOrder.orderId, part.sparePartId, $event)"
                                    title="Haz clic para ver información detallada del repuesto">
                                  <td class="px-3 py-2 text-sm" data-label="Nombre">
                                    <div class="flex items-center">
                                      <i class="fas mr-2 transition-transform duration-200"
                                         [ngClass]="isSparePartExpanded(folderOrder.orderSnapshot?.orderId || folderOrder.orderId, part.sparePartId) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                                      <div>
                                        <div class="font-medium">{{part.sparePartName}}</div>
                                        <div class="text-xs text-gray-500" *ngIf="part.comments && part.comments.length > 0">
                                          {{part.comments.length > 30 ? (part.comments | slice:0:30) + '...' : part.comments}}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td class="px-3 py-2 text-sm" data-label="Código">{{part.productCode}}</td>
                                  <td class="px-3 py-2 text-sm" data-label="Paquete">{{part.packageNumber || 'Sin asignar'}}</td>
                                  <td class="px-3 py-2" data-label="Estado">
                                    <span class="status-badge px-2 py-1 text-xs rounded-full" [ngClass]="getSparePartStatusClass(part.productStatus)">
                                      {{part.productStatus}}
                                    </span>
                                  </td>
                                  <td class="px-3 py-2 text-center text-sm font-medium" data-label="Cantidad">{{part.amount}}</td>
                                  <td class="px-3 py-2 text-right text-sm" data-label="Precio Unitario">{{part.unitPrice | currency}}</td>
                                  <td class="px-3 py-2 text-right text-sm font-semibold" data-label="Total">{{part.amount * part.unitPrice | currency}}</td>
                                  <td class="px-3 py-2 text-sm" data-label="Fecha de Llegada">{{formatDate(part.expectedArrivalDate)}}</td>
                                  <td class="px-3 py-2 text-sm" data-label="País">{{part.country}}</td>
                                </tr>
                                
                                <!-- Fila expandida con detalles completos del repuesto -->
                                <tr *ngIf="isSparePartExpanded(folderOrder.orderSnapshot?.orderId || folderOrder.orderId, part.sparePartId)" 
                                    class="bg-blue-50 border-b border-gray-200 fade-in">
                                  <td colspan="9" class="px-3 py-4">
                                    <div class="expanded-content bg-white rounded-lg shadow-sm border p-4">
                                      <h5 class="font-semibold mb-3 text-blue-800 flex items-center">
                                        <i class="fas fa-cog mr-2"></i>
                                        Información Detallada del Repuesto
                                      </h5>
                                      
                                      <!-- Grid de información detallada -->
                                      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                        <!-- Información básica -->
                                        <div class="space-y-2">
                                          <h6 class="font-medium text-gray-700 border-b pb-1">Información Básica</h6>
                                          <div class="text-sm">
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">ID:</span>
                                              <span class="font-medium">{{part.sparePartId}}</span>
                                            </div>
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">Nombre:</span>
                                              <span class="font-medium">{{part.sparePartName}}</span>
                                            </div>
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">Código:</span>
                                              <span class="font-medium">{{part.productCode}}</span>
                                            </div>
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">Número de Paquete:</span>
                                              <span class="font-medium text-blue-600 font-semibold">{{part.packageNumber || 'Sin asignar'}}</span>
                                            </div>
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">NCM:</span>
                                              <span class="font-medium">{{part.ncm || 'N/A'}}</span>
                                            </div>
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">Nota Fiscal:</span>
                                              <span class="font-medium">{{part.taxNote || 'N/A'}}</span>
                                            </div>
                                          </div>
                                        </div>
                                        
                                        <!-- Precios y cantidades -->
                                        <div class="space-y-2">
                                          <h6 class="font-medium text-gray-700 border-b pb-1">Precios y Cantidades</h6>
                                          <div class="text-sm">
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">Cantidad:</span>
                                              <span class="font-medium">{{part.amount}}</span>
                                            </div>
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">Precio Unitario:</span>
                                              <span class="font-medium">{{part.unitPrice | currency}}</span>
                                            </div>
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">Valor de Venta:</span>
                                              <span class="font-medium">{{part.valorDeVenta | currency}}</span>
                                            </div>
                                            <div class="flex justify-between py-1 bg-gray-100 px-2 rounded">
                                              <span class="text-gray-600 font-medium">Total:</span>
                                              <span class="font-bold">{{part.amount * part.unitPrice | currency}}</span>
                                            </div>
                                          </div>
                                        </div>
                                        
                                        <!-- Información de envío -->
                                        <div class="space-y-2">
                                          <h6 class="font-medium text-gray-700 border-b pb-1">Envío y Peso</h6>
                                          <div class="text-sm">
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">Estado de Envío:</span>
                                              <span class="font-medium">{{part.shippingStatus || 'N/A'}}</span>
                                            </div>
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">Remito:</span>
                                              <span class="font-medium">{{part.shippingReceipt || 'N/A'}}</span>
                                            </div>
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">Peso Neto:</span>
                                              <span class="font-medium">{{formatWeight(part.netWheight)}}</span>
                                            </div>
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">Peso Bruto:</span>
                                              <span class="font-medium">{{formatWeight(part.grossWheight)}}</span>
                                            </div>
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">País:</span>
                                              <span class="font-medium">{{part.country || 'N/A'}}</span>
                                            </div>
                                          </div>
                                        </div>
                                        
                                        <!-- Información brasileña -->
                                        <div class="space-y-2">
                                          <h6 class="font-medium text-gray-700 border-b pb-1">Información Brasil</h6>
                                          <div class="text-sm">
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">Código BR:</span>
                                              <span class="font-medium">{{part.codBr || 'N/A'}}</span>
                                            </div>
                                          </div>
                                        </div>
                                        
                                        <!-- Estados y fechas -->
                                        <div class="space-y-2">
                                          <h6 class="font-medium text-gray-700 border-b pb-1">Estados y Fechas</h6>
                                          <div class="text-sm">
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">Estado:</span>
                                              <span class="px-2 py-1 text-xs rounded-full" [ngClass]="getDetailedSparePartStatusClass(part.productStatus)">
                                                {{part.productStatus}}
                                              </span>
                                            </div>
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">Fecha de Llegada:</span>
                                              <span class="font-medium">{{formatDate(part.expectedArrivalDate)}}</span>
                                            </div>
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">Está Dañado:</span>
                                              <span class="font-medium" [ngClass]="part.isDamaged === 'true' ? 'text-red-600' : 'text-green-600'">
                                                {{formatBoolean(part.isDamaged === 'true')}}
                                              </span>
                                            </div>
                                            <div class="flex justify-between py-1">
                                              <span class="text-gray-600">Necesita Revisión:</span>
                                              <span class="font-medium" [ngClass]="part.needReview ? 'text-yellow-600' : 'text-green-600'">
                                                {{formatBoolean(part.needReview)}}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        
                                        <!-- Comentarios (columna completa) -->
                                        <div class="space-y-2 lg:col-span-1">
                                          <h6 class="font-medium text-gray-700 border-b pb-1">Comentarios</h6>
                                          <div class="text-sm">
                                            <p class="bg-gray-50 p-2 rounded min-h-[60px] text-gray-700">
                                              {{part.comments || 'Sin comentarios'}}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </ng-container>
                            </tbody>
                            <tfoot class="total-row">
                              <tr>
                                <td colspan="6" class="px-3 py-2 text-right font-semibold text-shadow">Total de la Orden:</td>
                                <td class="px-3 py-2 text-right font-bold text-lg text-shadow">{{getOrderTotalFromSnapshot(folderOrder) | currency}}</td>
                                <td colspan="2"></td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>

          <!-- Paginación mejorada -->
          <div class="mt-4 bg-gray-50 p-4 rounded-lg shadow-sm" *ngIf="totalPages > 1">
            <div class="flex justify-between items-center">
              <div class="text-sm text-gray-600">
                <span class="font-semibold">Página {{currentPage}} de {{totalPages}}</span>
                <span class="ml-2">({{totalOrders}} órdenes totales, {{selectedFolderOrders.length}} en esta página)</span>
              </div>
              <div class="flex space-x-2">
                <button 
                  (click)="goToPage(1)" 
                  [disabled]="currentPage === 1"
                  class="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
                  <i class="fas fa-angle-double-left"></i>
                </button>
                <button 
                  (click)="goToPage(currentPage - 1)" 
                  [disabled]="currentPage === 1"
                  class="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
                  <i class="fas fa-angle-left"></i>
                </button>
                
                <!-- Números de página -->
                <div class="flex space-x-1">
                  <ng-container *ngFor="let page of getPageNumbers()">
                    <span *ngIf="page === -1" class="px-2 py-1 text-gray-400">...</span>
                    <button 
                      *ngIf="page !== -1"
                      (click)="goToPage(page)"
                      [class.bg-blue-500]="page === currentPage"
                      [class.text-white]="page === currentPage"
                      [class.bg-gray-200]="page !== currentPage"
                      [class.hover:bg-gray-300]="page !== currentPage"
                      class="px-3 py-1 rounded">
                      {{page}}
                    </button>
                  </ng-container>
                </div>
                
                <button 
                  (click)="goToPage(currentPage + 1)" 
                  [disabled]="currentPage === totalPages"
                  class="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
                  <i class="fas fa-angle-right"></i>
                </button>
                <button 
                  (click)="goToPage(totalPages)" 
                  [disabled]="currentPage === totalPages"
                  class="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
                  <i class="fas fa-angle-double-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer del modal -->
      <div class="p-6 border-t bg-gray-50 flex justify-end space-x-3">
        <button 
          (click)="closeModal()" 
          class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div> 